var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWifi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 64,
    viewBox: "0 0 82 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.435 3.19414e-06C54.4611 -0.00456593 68.0471 4.89298 78.8448 13.8461C82.1609 16.5481 82.7994 19.5284 80.6788 22.0912C78.5581 24.6538 75.7658 24.474 72.4909 21.9027C52.669 6.0343 29.1683 6.07524 9.31278 22.0255C6.25037 24.482 3.16384 24.482 1.17404 21.9352C-0.815172 19.3891 -0.274364 16.7852 2.77945 14.2225C13.3221 5.29222 26.6209 0.268887 40.435 3.19414e-06Z",
    fill: "#FF5910"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0569 16.6632C51.6218 16.9128 60.7896 20.5384 67.9394 26.898C70.9607 29.5589 71.4439 32.5723 69.3147 34.9631C67.3009 37.2557 64.312 37.1328 61.4381 34.734C48.5178 24.016 33.8772 24.0081 20.7766 34.734C17.6324 37.2556 14.6768 37.2556 12.6133 34.742C10.673 32.3433 11.1643 29.592 14.0463 26.9637C21.121 20.5196 31.3952 16.614 42.0569 16.6632Z",
    fill: "#FF5910"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.041 33.2092C47.054 33.4005 52.8145 35.6684 57.3437 39.6287C59.923 41.9213 60.2422 44.9505 58.2855 47.1861C56.4515 49.2822 53.4874 49.4375 50.9167 47.5791C43.1629 42.0362 38.9788 42.0275 31.1752 47.5379C28.4897 49.4375 25.6568 49.2901 23.8064 47.1696C21.8412 44.885 22.2095 41.8637 24.7316 39.5797C28.7348 35.9278 35.7839 33.16 41.041 33.2092Z",
    fill: "#FF5910"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9025 50.939C42.5297 50.9321 44.094 51.5655 45.2586 52.7022C46.4225 53.8387 47.0931 55.3876 47.1257 57.0143C47.0623 58.5786 46.4186 60.0631 45.3192 61.1773C44.2198 62.2916 42.7446 62.9564 41.1813 63.0404C39.5547 63.0495 37.9931 62.4053 36.8464 61.2522C35.6997 60.0991 35.0639 58.5341 35.081 56.9081C35.0662 55.3454 35.6699 53.8406 36.7607 52.7222C37.8516 51.6039 39.3405 50.9624 40.9025 50.939Z",
    fill: "#FF5910"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifi);
export default __webpack_public_path__ + "static/media/wifi.f5ac6ebde21fba88cb937cb100d13ce4.svg";
export { ForwardRef as ReactComponent };